<template>
	<div class="h-100">
		<div
			v-if="appIsInitialized"
			ref="wrapper"
			class="app-wrapper-embedded"
		>
			<ViewMode />
		</div>
		<LoadingSpinner
			v-else
			center
		/>
		<ParallelViewModal
			v-if="parallelView"
			:parallel-view="parallelView"
			:event-id="parallelView.eventId || event.id"
		/>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { EVENT, bus } from '@videotools/js/events';
import { LoadingSpinner } from '@components/loader';
import ParallelViewModal from '@components/ParallelViewModal';

import ViewMode from './pages/ViewMode';

export default {
	name:       'App',
	components: { ViewMode, LoadingSpinner, ParallelViewModal },
	computed:   {
		...mapGetters({
			event:            'event/event',
			appIsInitialized: 'app/isInitialized',
			isFullscreen:     'device/isFullscreen',
			parallelView:     'error/parallelView',
		}),
	},
	watch: {
		isFullscreen: {
			handler:   'lockOrientation',
			immediate: true,
		},
	},
	async created() {
		bus.subscribe(EVENT.PARALLEL_VIEW_DETECTED, this.showParallelViewModal);
		this.syncInit();
		this.setAppTypeViewMode();
		// Activate If couchmode is needed on embeds
		// await this.loadEventExtra(this.event.id);
		this.setAppStateInitializing();
		this.syncSetup();
		this.setAppStateNormal();

		if (this.event) {
			this.$Analytics.trackEvent('Player', 'Loaded', {
				eventId:   this.event.id,
				eventName: this.event.name,
			});
		}
	},
	destroyed() {
		bus.unsubscribe(EVENT.PARALLEL_VIEW_DETECTED, this.showParallelViewModal);
	},
	methods: {
		...mapActions({
			// loadEventExtra:          'event/loadEventExtra', // Activate If couchmode is needed on embeds
			setAppStateInitializing: 'app/setAppStateInitializing',
			setAppStateNormal:       'app/setAppStateNormal',
			setAppTypeViewMode:      'app/setAppTypeViewMode',
			syncInit:                'sync/init',
			syncSetup:               'sync/setup',
			lockOrientation:         'device/lockOrientation',
			setParallelView:         'error/setParallelView',
		}),
		showParallelViewModal(view) {
			this.setParallelView(view);
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

.app-wrapper-embedded {
	width: 100%;
	height: 100%;
}

.h-100 {
	height: 100%;
}

.white-bg {
	background: var(--color-white);
}
</style>
